import type { IconSvgObject } from './types';

const UtensilsCrossedIcon: IconSvgObject = [
  ["path", { d: "M21.5 21.4998L12.5421 11.9998M12.5421 11.9998L3.58423 2.49976C2.02945 4.14864 2.20018 6.822 3.75496 8.47088L9.02312 14.2389C9.41182 14.6511 10.042 14.6511 10.4307 14.2389L12.5421 11.9998Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.5 2.49976L13 6.99975", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 10.9998L21.5 6.49976", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 16.9998L2.5 21.4998", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M15 8.99976L19.5 4.49976", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "4" }]
];

export default UtensilsCrossedIcon;
